import React from 'react'

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill='#202020'
        fillOpacity='0.5'
        d="M1.906 1.918L10.286.72a.333.333 0 01.38.33V14.95a.333.333 0 01-.38.33l-8.38-1.197a.666.666 0 01-.573-.66V2.578a.667.667 0 01.572-.66h.001zM11.333 2H14a.667.667 0 01.667.667v10.666A.667.667 0 0114 14h-2.667V2zM6.8 8l1.867-2.667h-1.6L6 6.857 4.933 5.333h-1.6L5.2 8l-1.867 2.667h1.6L6 9.143l1.067 1.524h1.6L6.8 8z"
      ></path>
    </svg>
  )
}

export default Icon
